/**
 * Generated by orval
 * Do not edit manually.
 * Veronics, Version=0.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AdminPaymentDetailDTO,
  AdminPaymentListItemDTOQueryResultDTO,
  AdminPaymentsGetPaymentsParams,
  FilterModelDTO,
  UpsertAdminPaymentDTO
} from './model';

import { customInstance } from '../custom-axios-instance';
import type { ErrorType } from '../custom-axios-instance';





export const adminPaymentsGetPayments = (
    organizationId: number,
    semesterId: number,
    filterModelDTO: FilterModelDTO[],
    params?: AdminPaymentsGetPaymentsParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<AdminPaymentListItemDTOQueryResultDTO>(
      {url: `/api/organizations/${organizationId}/admin/AdminPayments/list/${semesterId}`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: filterModelDTO,
        params, signal
    },
      );
    }
  


export const getAdminPaymentsGetPaymentsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminPaymentsGetPayments>>, TError,{organizationId: number;semesterId: number;data: FilterModelDTO[];params?: AdminPaymentsGetPaymentsParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof adminPaymentsGetPayments>>, TError,{organizationId: number;semesterId: number;data: FilterModelDTO[];params?: AdminPaymentsGetPaymentsParams}, TContext> => {
    
const mutationKey = ['adminPaymentsGetPayments'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminPaymentsGetPayments>>, {organizationId: number;semesterId: number;data: FilterModelDTO[];params?: AdminPaymentsGetPaymentsParams}> = (props) => {
          const {organizationId,semesterId,data,params} = props ?? {};

          return  adminPaymentsGetPayments(organizationId,semesterId,data,params,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AdminPaymentsGetPaymentsMutationResult = NonNullable<Awaited<ReturnType<typeof adminPaymentsGetPayments>>>
    export type AdminPaymentsGetPaymentsMutationBody = FilterModelDTO[]
    export type AdminPaymentsGetPaymentsMutationError = ErrorType<unknown>

    export const useAdminPaymentsGetPayments = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminPaymentsGetPayments>>, TError,{organizationId: number;semesterId: number;data: FilterModelDTO[];params?: AdminPaymentsGetPaymentsParams}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminPaymentsGetPayments>>,
        TError,
        {organizationId: number;semesterId: number;data: FilterModelDTO[];params?: AdminPaymentsGetPaymentsParams},
        TContext
      > => {

      const mutationOptions = getAdminPaymentsGetPaymentsMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const adminPaymentsGetPayment = (
    organizationId: number,
    id: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<AdminPaymentDetailDTO>(
      {url: `/api/organizations/${organizationId}/admin/AdminPayments/${id}`, method: 'GET', signal
    },
      );
    }
  

export const getAdminPaymentsGetPaymentQueryKey = (organizationId: number,
    id: number,) => {
    return [`/api/organizations/${organizationId}/admin/AdminPayments/${id}`] as const;
    }

    
export const getAdminPaymentsGetPaymentQueryOptions = <TData = Awaited<ReturnType<typeof adminPaymentsGetPayment>>, TError = ErrorType<unknown>>(organizationId: number,
    id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminPaymentsGetPayment>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminPaymentsGetPaymentQueryKey(organizationId,id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminPaymentsGetPayment>>> = ({ signal }) => adminPaymentsGetPayment(organizationId,id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(organizationId && id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminPaymentsGetPayment>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminPaymentsGetPaymentQueryResult = NonNullable<Awaited<ReturnType<typeof adminPaymentsGetPayment>>>
export type AdminPaymentsGetPaymentQueryError = ErrorType<unknown>


export function useAdminPaymentsGetPayment<TData = Awaited<ReturnType<typeof adminPaymentsGetPayment>>, TError = ErrorType<unknown>>(
 organizationId: number,
    id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminPaymentsGetPayment>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminPaymentsGetPayment>>,
          TError,
          Awaited<ReturnType<typeof adminPaymentsGetPayment>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminPaymentsGetPayment<TData = Awaited<ReturnType<typeof adminPaymentsGetPayment>>, TError = ErrorType<unknown>>(
 organizationId: number,
    id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminPaymentsGetPayment>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminPaymentsGetPayment>>,
          TError,
          Awaited<ReturnType<typeof adminPaymentsGetPayment>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminPaymentsGetPayment<TData = Awaited<ReturnType<typeof adminPaymentsGetPayment>>, TError = ErrorType<unknown>>(
 organizationId: number,
    id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminPaymentsGetPayment>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminPaymentsGetPayment<TData = Awaited<ReturnType<typeof adminPaymentsGetPayment>>, TError = ErrorType<unknown>>(
 organizationId: number,
    id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminPaymentsGetPayment>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminPaymentsGetPaymentQueryOptions(organizationId,id,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const adminPaymentsUpdatePayment = (
    organizationId: number,
    id: number,
    upsertAdminPaymentDTO: UpsertAdminPaymentDTO,
 ) => {
      
      
      return customInstance<AdminPaymentDetailDTO>(
      {url: `/api/organizations/${organizationId}/admin/AdminPayments/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: upsertAdminPaymentDTO
    },
      );
    }
  


export const getAdminPaymentsUpdatePaymentMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminPaymentsUpdatePayment>>, TError,{organizationId: number;id: number;data: UpsertAdminPaymentDTO}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof adminPaymentsUpdatePayment>>, TError,{organizationId: number;id: number;data: UpsertAdminPaymentDTO}, TContext> => {
    
const mutationKey = ['adminPaymentsUpdatePayment'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminPaymentsUpdatePayment>>, {organizationId: number;id: number;data: UpsertAdminPaymentDTO}> = (props) => {
          const {organizationId,id,data} = props ?? {};

          return  adminPaymentsUpdatePayment(organizationId,id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AdminPaymentsUpdatePaymentMutationResult = NonNullable<Awaited<ReturnType<typeof adminPaymentsUpdatePayment>>>
    export type AdminPaymentsUpdatePaymentMutationBody = UpsertAdminPaymentDTO
    export type AdminPaymentsUpdatePaymentMutationError = ErrorType<unknown>

    export const useAdminPaymentsUpdatePayment = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminPaymentsUpdatePayment>>, TError,{organizationId: number;id: number;data: UpsertAdminPaymentDTO}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminPaymentsUpdatePayment>>,
        TError,
        {organizationId: number;id: number;data: UpsertAdminPaymentDTO},
        TContext
      > => {

      const mutationOptions = getAdminPaymentsUpdatePaymentMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const adminPaymentsDeletePayment = (
    organizationId: number,
    id: number,
 ) => {
      
      
      return customInstance<void>(
      {url: `/api/organizations/${organizationId}/admin/AdminPayments/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getAdminPaymentsDeletePaymentMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminPaymentsDeletePayment>>, TError,{organizationId: number;id: number}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof adminPaymentsDeletePayment>>, TError,{organizationId: number;id: number}, TContext> => {
    
const mutationKey = ['adminPaymentsDeletePayment'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminPaymentsDeletePayment>>, {organizationId: number;id: number}> = (props) => {
          const {organizationId,id} = props ?? {};

          return  adminPaymentsDeletePayment(organizationId,id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AdminPaymentsDeletePaymentMutationResult = NonNullable<Awaited<ReturnType<typeof adminPaymentsDeletePayment>>>
    
    export type AdminPaymentsDeletePaymentMutationError = ErrorType<unknown>

    export const useAdminPaymentsDeletePayment = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminPaymentsDeletePayment>>, TError,{organizationId: number;id: number}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminPaymentsDeletePayment>>,
        TError,
        {organizationId: number;id: number},
        TContext
      > => {

      const mutationOptions = getAdminPaymentsDeletePaymentMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const adminPaymentsCreatePayment = (
    organizationId: number,
    upsertAdminPaymentDTO: UpsertAdminPaymentDTO,
 signal?: AbortSignal
) => {
      
      
      return customInstance<AdminPaymentDetailDTO>(
      {url: `/api/organizations/${organizationId}/admin/AdminPayments`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: upsertAdminPaymentDTO, signal
    },
      );
    }
  


export const getAdminPaymentsCreatePaymentMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminPaymentsCreatePayment>>, TError,{organizationId: number;data: UpsertAdminPaymentDTO}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof adminPaymentsCreatePayment>>, TError,{organizationId: number;data: UpsertAdminPaymentDTO}, TContext> => {
    
const mutationKey = ['adminPaymentsCreatePayment'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminPaymentsCreatePayment>>, {organizationId: number;data: UpsertAdminPaymentDTO}> = (props) => {
          const {organizationId,data} = props ?? {};

          return  adminPaymentsCreatePayment(organizationId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AdminPaymentsCreatePaymentMutationResult = NonNullable<Awaited<ReturnType<typeof adminPaymentsCreatePayment>>>
    export type AdminPaymentsCreatePaymentMutationBody = UpsertAdminPaymentDTO
    export type AdminPaymentsCreatePaymentMutationError = ErrorType<unknown>

    export const useAdminPaymentsCreatePayment = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminPaymentsCreatePayment>>, TError,{organizationId: number;data: UpsertAdminPaymentDTO}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminPaymentsCreatePayment>>,
        TError,
        {organizationId: number;data: UpsertAdminPaymentDTO},
        TContext
      > => {

      const mutationOptions = getAdminPaymentsCreatePaymentMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    